import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { cn } from '../../../lib/utils';
import { Button } from '../../../ui/button';
import {
  LayoutDashboard,
  Users,
  FileText,
  Package,
  FolderTree,
  BarChart3,
  Building2,
  Activity,
  DollarSign,
  Bell,
  ArrowLeft
} from 'lucide-react';

/**
 * Admin Navigation Component (shadcn/ui version)
 * Sidebar navigation for admin panel
 */
const AdminNavigationShadcn = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    {
      title: 'Dashboard',
      href: '/admin',
      icon: LayoutDashboard,
    },
    {
      title: 'Sponsors',
      href: '/admin/sponsors',
      icon: Users,
    },
    {
      title: 'Contracts',
      href: '/admin/contracts',
      icon: FileText,
    },
    {
      title: 'Inventory',
      href: '/admin/inventory',
      icon: Package,
    },
    {
      title: 'Categories',
      href: '/admin/categories',
      icon: FolderTree,
    },
    {
      title: 'Reports',
      href: '/admin/reports',
      icon: BarChart3,
    },
    {
      title: 'Performance',
      href: '/admin/performance',
      icon: Activity,
    },
    {
      title: 'Cost',
      href: '/admin/cost',
      icon: DollarSign,
    },
    {
      title: 'Engagement',
      href: '/admin/engagement',
      icon: Bell,
    },
    {
      title: 'Enterprise',
      href: '/admin/enterprises',
      icon: Building2,
    },
  ];

  const isActive = (href) => {
    if (href === '/admin') {
      return location.pathname === '/admin';
    }
    return location.pathname.startsWith(href);
  };

  return (
    <div className="flex flex-col h-full">
      {/* Header */}
      <div className="p-6 border-b">
        <h2 className="text-2xl font-bold tracking-tight">Admin</h2>
      </div>

      {/* Return to Aris Button */}
      <div className="p-4 border-b">
        <Button
          variant="outline"
          className="w-full justify-start"
          onClick={() => navigate('/dashboard')}
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Return to Aris
        </Button>
      </div>

      {/* Navigation Items */}
      <nav className="flex-1 p-4 space-y-1">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.href);
          
          return (
            <Link
              key={item.href}
              to={item.href}
              className={cn(
                "flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors",
                active
                  ? "bg-primary text-primary-foreground"
                  : "text-muted-foreground hover:bg-accent hover:text-accent-foreground"
              )}
            >
              <Icon className="h-4 w-4" />
              {item.title}
            </Link>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="p-4 border-t">
        <p className="text-xs text-muted-foreground">
          Sponsorship Admin v26.2
        </p>
      </div>
    </div>
  );
};

export default AdminNavigationShadcn;
